"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarDivider", {
    enumerable: true,
    get: function() {
        return ToolbarDivider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToolbarDividerStylesstyles = require("./useToolbarDividerStyles.styles");
const _reactdivider = require("@fluentui/react-divider");
const _useToolbarDivider = require("./useToolbarDivider");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarDivider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbarDivider.useToolbarDivider_unstable)(props, ref);
    (0, _useToolbarDividerStylesstyles.useToolbarDividerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarDividerStyles_unstable')(state);
    return (0, _reactdivider.renderDivider_unstable)(state);
});
ToolbarDivider.displayName = 'ToolbarDivider';
